"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.throttle = void 0;
// eslint-disable-next-line @typescript-eslint/ban-types
function throttle(fn, t, immediate) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var lastArgs, timer;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var noTimer = !timer;
        function timeoutFn() {
            if (lastArgs) {
                if (typeof fn === "function")
                    fn.apply(this, lastArgs);
                lastArgs = null;
                timer = setTimeout(timeoutFn, t);
            }
            else {
                timer = null;
            }
        }
        if (!noTimer || !immediate) {
            lastArgs = args;
        }
        if (!timer)
            timer = setTimeout(timeoutFn, t);
        if (immediate && noTimer && typeof fn === "function")
            fn.apply(this, args);
    };
}
exports.throttle = throttle;
//# sourceMappingURL=module.js.map